module.exports = __webpack_public_path__ + "assets/cd4da0792cd43d640fc7a1d8a24dc3c4.mp3";